export default "__VITE_ASSET__5758b9a2__"